<template>
  <div class="md:pt-32 lg:pt-0 pt-6 pb-12 relative z-index1 lg:mt-5 md:mt-10">
    <!-- <div class="absolute bg-faq-dots z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-dots.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="absolute bg-faq-poly1 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly1.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="absolute bg-faq-poly2 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly2.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div> -->
    <div class="w-full mx-auto lg:px-24 md:px-24 px-4 lg:pt-8 md:pt-10">
      <p
        class="title w-full sm-fsize16 lg:font-medium md:font-medium font-bold"
      >
        FAQ's
      </p>
      <!-- <div
        class="
          md:mt-10
          lg:mt-10
          mt-4
          md:py-6
          lg:py-6
          py-4
          md:px-8
          lg:px-8
          px-4
          cust-shadow-FAQ
          rounded-lg=
          bg-white
          z-10
        "
      > 
         <div
          class="flex items-center w-full justify-between cursor-pointer"
          block
          v-b-toggle.accordion-3
        >
          <p class="subtitle txt-FAQ-A fsize20-14px">
            Lorem ipsum dolor sit amet, consectetur eiusmod tempor adipiscing
            elit, sed do eiusmod tempor incididunt?
          </p>
          <img
            src="../../../assets/images/caregiver/downIcon.svg"
            alt="Downicon"
            class="md:h-4 lg:h-4 h-2 w-6"
          />
        </div>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <p class="subtitle pt-8 fsize20-14px">
            Lorem ipsum dolor sit amet, consectetur eiusmod tempor adipiscing
            elit, sed do eiusmod tempor incididunt? Lorem ipsum dolor sit amet,
            consectetur eiusmod tempor adipiscing elit, sed do eiusmod tempor
            incididunt?
          </p>
        </b-collapse>
      </div> -->
      <div
        class="md:mt-10 lg:mt-10 mt-4 md:py-6 lg:py-6 py-4 md:px-8 lg:px-8 px-4 cust-shadow-FAQ rounded-lg bg-white z-10"
        v-for="(item, index) in faq"
        :key="index"
      >
        <div
          class="flex items-center w-full justify-between cursor-pointer"
          block
          v-b-toggle="'accordion-' + index"
        >
          <p class="subtitle txt-FAQ-A fsize20-14px">
            {{ item.que }}
          </p>
          <img
            src="../../../assets/images/caregiver/downIcon.svg"
            alt="Downicon"
            class="md:h-4 lg:h-4 h-2 w-6"
          />
        </div>
        <b-collapse
          :id="'accordion-' + index"
          accordion="my-accordion"
          role="tabpanel"
        >
          <p class="subtitle pt-8 fsize20-14px">
            {{ item.answer }}
          </p>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      faq: [
        {
          id: "01",
          que: "How can we be more considerate and accomodating of our employees who are also caregivers?",
          answer:
            "We offer advisory services and learning interventions to guide you in building inclusive policies for the benefit of your employees. Contact us if you need further information regarding our services.",
        },
        {
          id: "02",
          que: "How can corporations be a part of Caregiver Saathi?",
          answer:
            "Our CSR partnership programme offers you opportunities to collaborate, volunteer and sponsor programmes for our initiatives to empower the marginalised caregivers. Contact us for further details.",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .smpt-33rem {
    padding-top: 33rem;
  }
}
</style>
